import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useState } from 'react';
var MediaState = {
  Playing: 'playing',
  Paused: 'paused',
  Stopped: 'stopped'
};
export default function useMedia(autoPlay) {
  var _useState = useState(autoPlay ? MediaState.Playing : MediaState.Stopped),
      _useState2 = _slicedToArray(_useState, 2),
      mediaState = _useState2[0],
      setMediaState = _useState2[1];

  var play = useCallback(function () {
    setMediaState(MediaState.Playing);
  }, []);
  var pause = useCallback(function () {
    if (MediaState.Playing) {
      setMediaState(MediaState.Paused);
    }
  }, []);
  var resume = useCallback(function () {
    if (MediaState.Paused) {
      setMediaState(MediaState.Playing);
    }
  }, []);
  var stop = useCallback(function () {
    setMediaState(MediaState.Stopped);
  }, []);
  return {
    isPlaying: mediaState === MediaState.Playing,
    play: play,
    pause: pause,
    resume: resume,
    stop: stop
  };
}